// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"403df6c5","369":"57278278","384":"61838339","550":"084e69c9","622":"640393b8","644":"12ca5c01","686":"7f043def","719":"713b19ae","780":"5cd128ae"}[chunkId] + ".chunk.js";
};